import React from 'react';
import PropTypes from 'prop-types';
import './FormField.css';

/**
 * FormField - Standardized form field wrapper
 * Provides consistent layout for label, input, help text, and error messages
 */
const FormField = ({
  label,
  htmlFor,
  required = false,
  error,
  helpText,
  children,
  className = '',
}) => {
  return (
    <div className={`ml-form-field ${error ? 'ml-form-field--error' : ''} ${className}`}>
      {label && (
        <label htmlFor={htmlFor} className="ml-form-field__label">
          {label}
          {required && <span className="ml-form-field__required">*</span>}
        </label>
      )}
      <div className="ml-form-field__control">{children}</div>
      {helpText && !error && <div className="ml-form-field__help">{helpText}</div>}
      {error && <div className="ml-form-field__error">{error}</div>}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  helpText: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default FormField;
